import React from "react";

import TooltipComponent from "@/main/components/shared/tooltip/tooltipComponent";
import { getTranslateByKey } from "@/main/services/utils";
import * as S from "./styles";

interface ICreateOrderBodyshopStepperProps {
	steps: string[];
	currentStep: string;
	completedSteps?: string[];
	isDisabled?: boolean;
	isLoading?: boolean;
	titleSteps?: Record<string, string>;
	onClickStep?: (step: string) => void;
}

function CreateOrderBodyshopStepper({
	currentStep,
	steps,
	completedSteps = [],
	titleSteps,
	isDisabled = false,
	isLoading = false,
	onClickStep = () => {},
}: ICreateOrderBodyshopStepperProps) {
	const currentIndex = steps.indexOf(currentStep);
	const getPreviousStep = (step: string) => steps[steps.indexOf(step) - 1];
	const isActive = (step: string) => completedSteps.includes(step) || completedSteps.includes(getPreviousStep(step));

	function titleStep(step: string) {
		return titleSteps ? titleSteps[step] : step;
	}

	function isLockedStep(step: string) {
		if (isDisabled) return true;
		return steps.indexOf(step) > currentIndex && !isActive(step);
	}

	function handleClickStep(event: React.MouseEvent<HTMLDivElement>, step: string) {
		event.preventDefault();
		event.stopPropagation();
		if (isLockedStep(step) || isLoading) return;

		onClickStep(step);
	}

	return (
		<S.Container>
			{steps.map((step, index) => (
				<TooltipComponent
					key={index}
					title={
						isActive(step) || currentStep === step
							? titleStep(step)
							: getTranslateByKey("information.completePreviousSteps")
					}
					placement="top"
				>
					<S.Segment
						$isClickable={!isLockedStep(step)}
						$isLoading={isLoading}
						onClick={(e) => handleClickStep(e, step)}
					>
						<S.Bar $isFilled={index <= currentIndex} />
					</S.Segment>
				</TooltipComponent>
			))}
		</S.Container>
	);
}

export default CreateOrderBodyshopStepper;
